import ForensicSoftwareAPI from "@/api/software";
import { SelectBox } from "@monolith-forensics/monolith-ui";
import { useQuery } from "@tanstack/react-query";
import { FC } from "react";

interface SoftwareSelectorProps {
  defaultValue?: string;
  onChange?: (value: string) => void;
  error?: string;
  openOnFocus?: boolean;
  isRequired?: boolean;
  value?: string;
}

type Software = {
  software_name: string;
};

const SoftwareSelector: FC<SoftwareSelectorProps> = ({
  defaultValue,
  value,
  onChange,
  error,
  openOnFocus = false,
  isRequired = false,
}) => {
  const { data: softwareList } = useQuery<Software[]>({
    queryKey: ["software", "names"],
    queryFn: () => ForensicSoftwareAPI.getSoftwareNames(),
  });

  let options =
    softwareList?.map((software) => ({
      label: software?.software_name,
      value: software?.software_name,
    })) || [];

  // If there's a defaultValue that doesn't exist in options, add it
  if (
    defaultValue &&
    !options.some((option) => option.value === defaultValue)
  ) {
    options = [...options, { label: defaultValue, value: defaultValue }];
  }

  return (
    <>
      <SelectBox
        defaultValue={defaultValue}
        size="sm"
        variant="outlined"
        label="Software"
        placeholder="Select or enter software name"
        description="This is the software that was used to perform the acquisition."
        onChange={onChange}
        data={options}
        error={error}
        clearable={true}
        searchable={true}
        allowCustomValue={true}
        openOnFocus={openOnFocus}
        required={isRequired}
      />
    </>
  );
};
export default SoftwareSelector;
